@import './styles/fonts';
// Icon fonts for material icons.
@import './styles/material_design_icons';
@import './styles/bootstrap/bootstrap.scss';

body {
  margin: 0;
  font-family: 'Roboto', sans-serif;
  background: $siteBackground !important;
}

@import './styles/custom';

// MUI overrides.
@import './styles/mui';
